import React from 'react';

const PrivatePortfolioItem = ({ portfolio, categoryMap }) => {
    return (
        <article className="rwt-card" aria-label={`Portfolio item: ${portfolio.title.rendered}`}>
            <div className="inner">
                <div className="thumbnail">
                    <figure className="card-image">
                        <a href={portfolio.acf.portfolio_link} target="_blank" rel="noopener noreferrer" aria-label={`View portfolio: ${portfolio.title.rendered}`}>
                            <img className="img-fluid" src={portfolio.acf.portfolio_image} alt={`${portfolio.title.rendered} portfolio preview`} />
                        </a>
                    </figure>
                    <a href={portfolio.acf.portfolio_link} target="_blank" rel="noopener noreferrer" className="rwt-overlay" aria-label={`Open portfolio: ${portfolio.title.rendered}`} tabIndex="-1"></a>
                </div>
                <div className="content">
                    <h3 className="title mb--10">
                        <a href={portfolio.acf.portfolio_link} target="_blank" rel="noopener noreferrer">
                            {portfolio.title.rendered}
                        </a>
                    </h3>

                    {/* Displaying the portfolio category names */}
                    {/* <span>{portfolio.acf.portfolio_category.map((category) => categoryMap[category]).join(', ')}</span> */}
                </div>
            </div>
        </article>
    );
};

export default PrivatePortfolioItem;
